import React from "react";
import "../App.css";

const Loader = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
